export default "__VITE_ASSET__BOMRo2Wl__"